import {
  setLotSizeValue,
  wantAdBudgetValue,
  wantAdSqftValue,
} from "../../../helpers/createWantAd";
import {
  getUserId,
  locationDisplay,
  getUserType,
  capitalizeFirstString,
} from "../../../helpers/common";
import { USER_TYPE_AGENT } from "../../../constants/common";
import {
  getPropertyArticle,
  getPropertyTextShare,
} from "../../../helpers/v2/shareWantad";
import GitchaLogo from "../../../images/v2/Gitcha-Logo.svg";

// Card preview for share want ad
const ShareCardPreview = ({ adDetails, isSideCard = false }) => {
  const WantCreatedUserId = _.get(adDetails, "userId", false);
  const loggedInUserId = getUserId();
  const isAgentCreated = _.get(adDetails, "isAgentCreated", "") == 1;
  const adType = _.get(adDetails, "adType", "");
  const adTypeText = adType === "BUY" ? "BUY" : "RENT";
  const propertyType = getPropertyTextShare(adDetails);
  const prprtyType = _.get(adDetails, "prprtyType", []);
  const clientName = _.get(adDetails, "clientName", []);
  const article = getPropertyArticle(propertyType);
  let bdgt = wantAdBudgetValue(
    _.get(adDetails, "minBdgt", ""),
    _.get(adDetails, "maxBdgt", ""),
  );
  let sqFt = wantAdSqftValue(
    _.get(adDetails, "sqFtMin", ""),
    _.get(adDetails, "sqFtMax", ""),
  );

  let ltSize = setLotSizeValue(
    _.get(adDetails, "minLtSz", null),
    _.get(adDetails, "maxLtSz", null),
  );
  let noBedRoom = _.get(adDetails, "noBedRm", null);
  let noBathRoom = _.get(adDetails, "noBathRm", null);

  if (noBathRoom && noBathRoom !== "Any") noBathRoom = noBathRoom + "+";
  if (noBedRoom && noBedRoom !== "Any") noBedRoom = noBedRoom + "+";
  const userType = getUserType();
  const isAgent = userType === USER_TYPE_AGENT ? true : false;

  return (
    <div
      className={`share-yourad-map-preview ${
        isSideCard ? "sidecard-preview" : ""
      }`}
    >
      <div className="share-yourad-map-preview-background-image" />
      <div className="share-yourad-map-preview-overlay" />
      <div className="share-yourad-map-preview-content">
        {isAgent ? (
          <>
            {WantCreatedUserId !== loggedInUserId ? (
              <>
                <h1
                  className={`share-yourad-map-preview-title ${isSideCard ? "f-size-24 " : ""}`}
                >
                  Looking to {adTypeText}
                </h1>
                <p className="share-yourad-map-preview-location mb-20">
                  {article} {propertyType} {locationDisplay(adDetails, true)}
                </p>
              </>
            ) : (
              <>
                <p className="share-yourad-map-preview-subtitle">
                  I HAVE A NEW
                </p>
                <h1
                  className={`share-yourad-map-preview-title ${isSideCard ? "f-size-24 " : ""}`}
                >
                  {adTypeText}ER NEED
                </h1>

                <p className="share-yourad-map-preview-location">
                  Looking {locationDisplay(adDetails, true)}
                </p>
              </>
            )}
          </>
        ) : (
          <>
            <h1
              className={`share-yourad-map-preview-title ${
                isSideCard ? "f-size-16" : "f-size-24 "
              }  `}
            >
              {WantCreatedUserId !== loggedInUserId
                ? `LOOKING TO ${adTypeText}`
                : `I'M LOOKING TO ${adTypeText}`}
            </h1>
            <p className="share-yourad-map-preview-location mb-20">
              {capitalizeFirstString(article)} {propertyType}{" "}
              {locationDisplay(adDetails, true)}
            </p>
          </>
        )}
        {prprtyType != "6" && prprtyType != "11" ? (
          <div className="share-yourad-map-preview-specs">
            <div>
              Beds: {noBedRoom} | Baths: {noBathRoom}
            </div>
            <div>Sqft: {sqFt}</div>
            <div>Budget: {bdgt}</div>
            <div className="share-yourad-map-preview-btmLine">
              {WantCreatedUserId === loggedInUserId && isAgentCreated ? (
                adDetails?.syndicationPrivacy === "show" && (
                  //TODO white card uncomment
                  <div
                    className={`small-card-agent-card ${
                      !adDetails?.userAvatar ? "small-card-no-image" : ""
                    }`}
                  >
                    {adDetails?.userAvatar && (
                      <img
                        src={adDetails?.userAvatar}
                        alt="Agent Avatar"
                        className="small-card-agent-avatar"
                      />
                    )}
                    <div className="small-card-agent-info">
                      <div className="small-card-agent-name">
                        {adDetails?.userFirstName} {adDetails?.userLastName}{" "}
                        <span className="small-card-pro-label">PRO</span>
                      </div>
                      <div className="small-card-agent-detail">
                        Agent @ {adDetails?.userCompany}
                      </div>
                      <div className="small-card-agent-detail">
                        {adDetails?.userPhone}
                      </div>
                    </div>
                  </div>
                )
              ) : (
                <>
                  <div className="share-yourad-map-preview-btmLine-text">
                    {WantCreatedUserId !== loggedInUserId
                      ? `Find more details listed by this ${
                          !isAgentCreated
                            ? adTypeText === "BUY"
                              ? "buyer"
                              : "renter"
                            : "agent"
                        } on`
                      : "Find more details listed on"}
                  </div>
                  <div
                    className={`share-yourad-map-preview-btmLine-logo ${WantCreatedUserId !== loggedInUserId ? "" : "logo-center"}`}
                  >
                    <img src={GitchaLogo} alt="Gitcha Logo" />
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          <div className="share-yourad-map-preview-specs">
            {prprtyType != "11" && <div>Lot Size: {ltSize}</div>}
            <div>Budget: {bdgt}</div>
            <div className="share-yourad-map-preview-btmLine">
              <div className="share-yourad-map-preview-btmLine-text">
                {WantCreatedUserId !== loggedInUserId &&
                  `Find more details listed by this ${clientName ? (adTypeText === "BUY" ? "buyer" : "renter") : "agent"} on`}
                {WantCreatedUserId == loggedInUserId &&
                  "Find more details listed on"}
              </div>

              <div
                className={`share-yourad-map-preview-btmLine-logo ${WantCreatedUserId !== loggedInUserId ? "" : "logo-center"}`}
              >
                <img src={GitchaLogo} alt="Gitcha Logo" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareCardPreview;
